import get from 'lodash/get';
import api from '../lib/api';

export const FETCH_ALL_TASKS = 'FETCH_ALL_TASKS';
export const SET_ONE_TASK = 'SET_ONE_TASK';
export const FETCH_ONE_TASK = 'FETCH_ONE_TASK';
export const CLEAR_ONE_TASK = 'CLEAR_ONE_TASK';
export const ONE_TASK_LOADING = 'ONE_TASK_LOADING';
export const FETCH_USER_TASKS = 'FETCH_USER_TASKS';
export const FETCH_MARKET_TASKS = 'FETCH_MARKET_TASKS';
export const TASKS_LOADING = 'TASKS_LOADING';

function fetchTasks(query, override) {
  return (dispatch) => {
    const owner = get(query, 'owner_id');
    // sometimes we want to fetch tasks
    // and not start spinner, like when....
    // ...the query comes from the usersTable (has owner_id)
    // or...from the global view of tasks
    if (!owner && !override) {
      dispatch({ type: TASKS_LOADING, payload: true });
    }

    return api.getTasks(query)
      .then((tasks) => {
        const market = get(query, 'market_id');

        if (owner) {
          dispatch({ type: FETCH_USER_TASKS, payload: tasks });
        } else if (market) {
          dispatch({ type: FETCH_MARKET_TASKS, payload: tasks });
        } else {
          dispatch({ type: FETCH_ALL_TASKS, payload: tasks });
        }
      })
      .then(() => {
        dispatch({ type: TASKS_LOADING, payload: false });
      })
      .catch(() => {
        dispatch({ type: TASKS_LOADING, payload: false });
      });
  };
}

function fetchOneTask(taskId) {
  return (dispatch) => {
    dispatch({ type: ONE_TASK_LOADING, payload: true });

    return api.getOneTask(taskId)
      .then((data) => {
        dispatch({ type: FETCH_ONE_TASK, payload: data });
      })
      .then(() => {
        dispatch({ type: ONE_TASK_LOADING, payload: false });
      })
      .catch((data) => {
        dispatch({ type: ONE_TASK_LOADING, payload: false });
        return data;
      });
  };
}

function clearOneTask() {
  return (dispatch) => {
    dispatch({ type: CLEAR_ONE_TASK });
  };
}

function setOneTask(data) {
  return (dispatch) => {
    dispatch({ type: SET_ONE_TASK, payload: data });
  };
}

export default {
  fetchTasks,
  fetchOneTask,
  clearOneTask,
  setOneTask,
  createTask(task) {
    return () => api.createTask(task);
  },
  createTasksForVehicles(taskData, vehicleIds) {
    return () => api.createTasksForVehicles(taskData, vehicleIds);
  },
  createTasksForCases(taskData, caseData) {
    return () => api.createTasksForCases(taskData, caseData);
  },
  updateTask(task, taskId) {
    return () => api.updateTask({ ...task, assignedVehicles: [] }, taskId);
  },
  bulkUpdateTaskStatus(arrayOfTaskIds) {
    return () => api.bulkUpdateTaskStatus(arrayOfTaskIds);
  },
  bulkUpdateTaskOwner(arrayOfTaskIds, ownerId) {
    return () => api.bulkUpdateTaskOwner(arrayOfTaskIds, ownerId);
  },
};
